module.exports = __webpack_public_path__ + "static/img/db-3.a73661e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin/db-3.svg
// module id = E9uP
// module chunks = 1